import { Empty } from 'antd';

interface Props {
  description?: string;
  children?: React.ReactNode;
}

export function EmptyState({ description = 'Sin Datos', children }: Props) {
  return (
    <div style={{ padding: 48 }}>
      <Empty description={description}>{children}</Empty>
    </div>
  );
}
